export default {
  independentMarketing: {
    common: {
      requestFailed: 'בקשת הממשק נכשלה',
      hintSelect: 'בחר',
      hintInput: 'להיכנס',
      submit: 'שלח',
      cancel: 'לְבַטֵל',
      confirm: 'בסדר',
    },
    agreement: {
      title: 'הסכם רישום עוסק עצמאי של Autel',
      nextBtn: 'הבא',
      getAgreementFailed: '.קבלת תוכן ההסכם נכשלה',
    },
    successPage: {
      title:
        '.פרטי הבקשה שלך נשלחו בהצלחה ותוצאות הבדיקה יישלחו למייל שלך $1 תוך 15 ימי עבודה. אנא בדוק את תיבת הדואר הנכנס שלך לקבלת מידע נוסף',
      subTitle: '.חזור לדף הבית לאחר שניות של $1',
    },
    applyTitle: 'אתה מגיש בקשה להיות סוחר עצמאי של Autel. נא למלא את הפרטים הבאים במדויק:',
    companyName: 'שם החברה',
    companyTax: 'מזהה מע"מ',
    userCountry: 'מדינה',
    legalPerson: 'יועץ משפטי',
    contactEmail: 'אימייל ליצירת קשר',
    contactEmailTips:
      '.כתובת דוא"ל זו תהיה איש הקשר שלך בדוא"ל תוצאת הבדיקה. לאחר אישור הסקירה, היא תשמש גם כשם חשבון הכניסה למערכת ניהול העוסק העצמאי',
    corporateIdentity: 'מזהה יועץ משפטי',
    uploadTips: 'JPG, JPEG, PNG, PDF (לא יותר מ-20 MB)',
    businessLicense: 'רשיון עסקי',
    emailErrorTips: '.הזן דואר אלקטרוני חוקי',
    uploadPic: 'להעלות תמונות',
    picMaxLimit: '.גודל התמונה המרבי הוא 20 מגה-בייט. אנא בחר שוב',
  },
};
